import React, { useState } from "react";
import styles from "./MobileDeviceTable.module.scss";
import { useTranslation } from "react-i18next";
import download from "../../assets/icons/download.svg";
import cancel from "../../assets/icons/disable.svg";
import cancelHover from "../../assets/icons/cancel-hover.svg";

interface MobileDeviceProps {
  item: {
    machine_id: string;
    machine_name: string;
    os_name: string;
    downloadLink?: string;
  };
  trial?: boolean;

  itemKey?: string;
  showToast: (message: string) => void;
  setCurrentDeviceDeactivate: (device: any) => void;
  setIsModalDeactivateVisible: (visible: boolean) => void;
  setIsLicenseModalVisible: (visible: boolean, itemKey: string, name: string) => void;
}

const MobileDeviceItem: React.FC<MobileDeviceProps> = ({
  item,
  trial,
  itemKey,
  showToast,
  setCurrentDeviceDeactivate,
  setIsModalDeactivateVisible,
  setIsLicenseModalVisible,
}) => {
  const { t } = useTranslation();
  const [showFullText, setShowFullText] = useState(false);

  const fullText = item.machine_name || item.machine_id || "";
  const isTruncated = fullText.length > 15;
  const displayText = isTruncated ? fullText.substring(0, 15) + "..." : fullText;

  return (
    <div className={styles.root_list}>
      {itemKey && (
        <div className={`${styles.root_list_item} ${styles.root_list_item_spread}`}>
          <p className={styles.root_list_item_property}>{t("License Key")}</p>
          <p
            className={styles.root_list_item_link}
            onClick={() => setIsLicenseModalVisible(true, itemKey, t("License Key"))}
          >
            {t("Show")}
          </p>
        </div>
      )}
      <div className={styles.root_list_item}>
        <p className={styles.root_list_item_property}>{t("Device Name")}</p>
        <p
          className={styles.root_list_item_value}
          onClick={() => setShowFullText(!showFullText)}
          style={{ wordBreak: "break-all" }}
        >
          {showFullText ? fullText : displayText}
        </p>
      </div>
      <div className={styles.root_list_item}>
        <p className={styles.root_list_item_property}>{t("Operating System")}</p>
        <p className={styles.root_list_item_value}>{item.os_name}</p>
      </div>

      {trial ? (
        <div
          className={styles.root_install_trial}
          onClick={() => {
            showToast(t("Install by clicking the download file"));
            setTimeout(() => {
              window.open(item?.downloadLink, "_blank");
            }, 300);
          }}
        >
          <img src={download} alt="download" width={24} height={24} />
          <p>{t("Installer")}</p>
        </div>
      ) : (
        <div className={styles.root_list_actions}>
          <div
            className={styles.root_list_actions_install}
            onClick={() => {
              showToast(t("Install by clicking the download file"));
              setTimeout(() => {
                window.open(item?.downloadLink, "_blank");
              }, 300);
            }}
          >
            <img src={download} alt="download" width={24} height={24} />
            <p>{t("Installer")}</p>
          </div>
          <div
            className={styles.root_list_actions_cancel}
            onClick={() => {
              setCurrentDeviceDeactivate(item);
              setIsModalDeactivateVisible(true);
            }}
          >
            <img
              src={cancel}
              alt="cancel"
              onMouseOver={(e) => (e.currentTarget.src = cancelHover)}
              onMouseOut={(e) => (e.currentTarget.src = cancel)}
            />
            <p>{t("Deauthorize")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileDeviceItem;
